export const REQUEST_LIBRARY_CONTENT = "REQUEST_LIBRARY_CONTENT";
export const SET_LIBRARY_CONTENT = "SET_LIBRARY_CONTENT";
export const REVOKE_LIBRARY_CONTENT = "REVOKE_LIBRARY_CONTENT";
export const RESET_LIBRARY_CONTENT = "RESET_LIBRARY_CONTENT";

export const CHANGE_LIBRARY_MODALS = "CHANGE_LIBRARY_MODALS";
export const SET_LIBRARY_ACTIVE_FILE = "SET_LIBRARY_ACTIVE_FILE";
export const CLEAR_LIBRARY_ACTIVE_FILE = "CLEAR_LIBRARY_ACTIVE_FILE";

export const REQUEST_FILE_ACCESS = "REQUEST_FILE_ACCESS";
export const REVOKE_FILE_ACCESS = "REVOKE_FILE_ACCESS";
export const GRANT_FILE_ACCESS = "GRANT_FILE_ACCESS";
export const RESET_FILE_ACCESS = "RESET_FILE_ACCESS";

export const REQUEST_FILE_DELETION = "REQUEST_FILE_DELETION";
export const REVOKE_FILE_DELETION = "REVOKE_FILE_DELETION";
export const GRANT_FILE_DELETION = "GRANT_FILE_DELETION";
export const RESET_FILE_DELETION = "RESET_FILE_DELETION";

export const REQUEST_FILE_UPLOAD = "REQUEST_FILE_UPLOAD";
export const REVOKE_FILE_UPLOAD = "REVOKE_FILE_UPLOAD";
export const GRANT_FILE_UPLOAD = "GRANT_FILE_UPLOAD";
export const RESET_FILE_UPLOAD = "RESET_FILE_UPLOAD";

export const SET_ACTIVE_FILE_SETTINGS = "SET_ACTIVE_FILE_SETTINGS";
export const RESET_ACTIVE_FILE_SETTINGS = "RESET_ACTIVE_FILE_SETTINGS";

export const REQUEST_ADD_PASSWORD_FILE = "REQUEST_ADD_PASSWORD_FILE";
export const REVOKE_ADD_PASSWORD_FILE = "REVOKE_ADD_PASSWORD_FILE";
export const GRANT_ADD_PASSWORD_FILE = "GRANT_ADD_PASSWORD_FILE";
export const RESET_ADD_PASSWORD_FILE = "RESET_ADD_PASSWORD_FILE";

export const REQUEST_REMOVE_PASSWORD_FILE = "REQUEST_REMOVE_PASSWORD_FILE";
export const REVOKE_REMOVE_PASSWORD_FILE = "REVOKE_REMOVE_PASSWORD_FILE";
export const GRANT_REMOVE_PASSWORD_FILE = "GRANT_REMOVE_PASSWORD_FILE";
export const RESET_REMOVE_PASSWORD_FILE = "RESET_REMOVE_PASSWORD_FILE";

export const APPEND_FILES_DELETION_ARRAY = "APPEND_FILES_DELETION_ARRAY";
export const SUBTRACT_FILES_DELETION_ARRAY = "SUBTRACT_FILES_DELETION_ARRAY";

export const REQUEST_DELETE_FILE_ARRAY = "REQUEST_DELETE_FILE_ARRAY";
export const REVOKE_DELETE_FILE_ARRAY = "REVOKE_DELETE_FILE_ARRAY";
export const RESET_DELETE_FILE_ARRAY = "RESET_DELETE_FILE_ARRAY";
export const GRANT_DELETE_FILE_ARRAY = "GRANT_DELETE_FILE_ARRAY";
